import { Routes, Route, Router } from "react-router-dom";
import {
  ADDFABRIC,
  DETAILFABRIC,
  EDITFABRIC,
  FABRIC,
  LOGIN,
  STYLEACCENT,
  DETAILSTYLEACCENT,
  USER,
  EDITUSER,
  DETAILUSER,
  PRODUCTCATEGORY,
  ADDPRODUCTCATEGORY,
  EDITPRODUCTCATEGORY,
  DASHBOARD,
  PENDINGTRANSACTION,
  GENERATEQR,
  TEMPLATEQR,
  CONFIRMEDTRANSACTION,
  REFUNDTRANSACTION,
  CANCELEDTRANSACTION,
  REPORTDATA,
  TRANSACTIONCONFIRMDETAIL,
  TRANSACTIONCANCELEDDETAIL,
  TRANSACTIONPENDINGDETAIL,
  TRANSACTIONREFUNDDETAIL,
  ADMINISTRATOR,
  EDITADMINISTRATOR,
  ADDADMINISTRATOR,
  DETAILADMINISTRATOR,
  PRODUCTLIST,
  ADDPRODUCTLIST,
  EDITPRODUCTLIST,
  SETAPPEARANCE,
  SETFABRICSTYLE,
  NotHaveAccess,
  ADDFABRICSET,
  STYLEOPTIONS,
  ADDSTYLEOPTIONS,
  EDITSTYLEOPTIONS,
  DETAILSTYLEOPTIONS,
} from "./routes_name";
import LoginPage from "../pages/auth/login";
import FabricPage from "../pages/fabric";
import NotFoundPage from "../pages/not_found";
import ProtectedRoute from "../helpers/protected_route";
import StyleAccentPage from "../pages/style_accent";

// Style Options
import StyleOptionsPage from "../pages/style_options";
import AddStyleOptionsPage from "../pages/style_options/add";
import EditStyleOptionsPage from "../pages/style_options/edit";
import DetailStyleOptionsPage from "../pages/style_options/detail";

import AddFabricsPage from "../pages/fabric/add";
import EditFabricsPage from "../pages/fabric/edit";
import DetailFabricPage from "../pages/fabric/detail";
import DetailStyleAccentPage from "../pages/style_accent/detail";
import Dashboard from "../pages/dashboard/dashboard";
import GenerateQrFabricsPage from "../pages/fabric/qr";
import TemplatQrPage from "../pages/template_qr";
import ReportPage from "../pages/reports/reports";

/* Transaction Pages */
import TransactionDetail from "../pages/transactions/detail/detail-transaction";
import PendingTransactions from "../pages/transactions/pendingTransactions";
import ConfirmTransactions from "../pages/transactions/confirmTransactions";
import CanceledTransactions from "../pages/transactions/canceledTransactions";
import RefundTransactions from "../pages/transactions/refundTransactions";
import TransactionDetailCanceled from "../pages/transactions/detail/detail-canceled";

// Master Pages
import UserPage from "../pages/master/user";
import EditUserPage from "../pages/master/user/edit";
import DetailUserPage from "../pages/master/user/detail";

// Master -> Product Category
import ProductCategoryPage from "../pages/master/product_category";
import AddProductCategoryPage from "../pages/master/product_category/add";
import EditProductCategoryPage from "../pages/master/product_category/edit";

import AdministratorPage from "../pages/master/administrator";
import AddAdministratorPage from "../pages/master/administrator/add";
import EditAdministratorPage from "../pages/master/administrator/edit";
import DetailAdministratorPage from "../pages/master/administrator/detail";
import ProductListPage from "../pages/master/product_list";
import AddProductListPage from "../pages/master/product_list/add";
import EditProductListPage from "../pages/master/product_list/edit";

// Settings Pages
import SetAppearancePage from "../pages/settings/appearance";
import SetFabricStylePage from "../pages/settings/fabric_style";
import AddSetFabricStylePage from "../pages/settings/fabric_style/add";
import EditSetFabricStylePage from "../pages/settings/fabric_style/edit";
import DetailSetFabricStylePage from "../pages/settings/fabric_style/detail";

// Pages Not Have Access
import NotHaveAccessPage from "../pages/error/403";

const Navigation = () => {
  return (
    <>
      <Routes>
        <Route
          path={LOGIN}
          element={
            <ProtectedRoute>
              <LoginPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={DASHBOARD}
          element={
            <ProtectedRoute isLogin requiredFeature="dashboard">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={FABRIC}
          element={
            <ProtectedRoute isLogin requiredFeature="fabrics">
              <FabricPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ADDFABRIC}
          element={
            <ProtectedRoute isLogin requiredFeature="fabrics">
              <AddFabricsPage />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={ADDFABRICSET}
          element={
            <ProtectedRoute isLogin requiredFeature="fabrics">
              <AddFabricsPage />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={EDITFABRIC}
          element={
            <ProtectedRoute isLogin requiredFeature="fabrics">
              <EditFabricsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={DETAILFABRIC}
          element={
            <ProtectedRoute isLogin requiredFeature="fabrics">
              <DetailFabricPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={STYLEACCENT}
          element={
            <ProtectedRoute isLogin requiredFeature="style_accents">
              <StyleAccentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={DETAILSTYLEACCENT}
          element={
            <ProtectedRoute isLogin requiredFeature="style_accents">
              <DetailStyleAccentPage />
            </ProtectedRoute>
          }
        />

        {/* Style Options Menu */}
        <Route
          path={STYLEOPTIONS}
          element={
            <ProtectedRoute isLogin requiredFeature="style_accents">
              <StyleOptionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ADDSTYLEOPTIONS}
          element={
            <ProtectedRoute isLogin requiredFeature="style_accents">
              <AddStyleOptionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={EDITSTYLEOPTIONS}
          element={
            <ProtectedRoute isLogin requiredFeature="style_accents">
              <EditStyleOptionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={DETAILSTYLEOPTIONS}
          element={
            <ProtectedRoute isLogin requiredFeature="style_accents">
              <DetailStyleOptionsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path={PENDINGTRANSACTION}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <PendingTransactions />
            </ProtectedRoute>
          }
        />
        <Route
          path={CONFIRMEDTRANSACTION}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <ConfirmTransactions />
            </ProtectedRoute>
          }
        />
        <Route
          path={TRANSACTIONPENDINGDETAIL}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <TransactionDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={TRANSACTIONCONFIRMDETAIL}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <TransactionDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={TRANSACTIONCANCELEDDETAIL}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <TransactionDetailCanceled />
            </ProtectedRoute>
          }
        />
        <Route
          path={TRANSACTIONREFUNDDETAIL}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <TransactionDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={CANCELEDTRANSACTION}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <CanceledTransactions />
            </ProtectedRoute>
          }
        />
        <Route
          path={REFUNDTRANSACTION}
          element={
            <ProtectedRoute isLogin requiredFeature="transactions">
              <RefundTransactions />
            </ProtectedRoute>
          }
        />
        <Route
          path={REPORTDATA}
          element={
            <ProtectedRoute isLogin requiredFeature="report">
              <ReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={GENERATEQR}
          element={
            <ProtectedRoute isLogin requiredFeature="fabrics">
              <GenerateQrFabricsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={TEMPLATEQR}
          element={
            <ProtectedRoute isLogin>
              <TemplatQrPage />
            </ProtectedRoute>
          }
        />
        {/* Menu master */}
        <Route
          path={ADMINISTRATOR}
          element={
            <ProtectedRoute isLogin requiredFeature="master.administrator">
              <AdministratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ADDADMINISTRATOR}
          element={
            <ProtectedRoute isLogin requiredFeature="master.administrator">
              <AddAdministratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={EDITADMINISTRATOR}
          element={
            <ProtectedRoute isLogin requiredFeature="master.administrator">
              <EditAdministratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={DETAILADMINISTRATOR}
          element={
            <ProtectedRoute isLogin requiredFeature="master.administrator">
              <DetailAdministratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={USER}
          element={
            <ProtectedRoute isLogin requiredFeature="master.user">
              <UserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={EDITUSER}
          element={
            <ProtectedRoute isLogin requiredFeature="master.user">
              <EditUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={DETAILUSER}
          element={
            <ProtectedRoute isLogin requiredFeature="master.user">
              <DetailUserPage />
            </ProtectedRoute>
          }
        />
        {/* START Product Category */}
        <Route
          path={PRODUCTCATEGORY}
          element={
            <ProtectedRoute isLogin requiredFeature="master.product_category">
              <ProductCategoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ADDPRODUCTCATEGORY}
          element={
            <ProtectedRoute isLogin requiredFeature="master.product_category">
              <AddProductCategoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={EDITPRODUCTCATEGORY}
          element={
            <ProtectedRoute isLogin requiredFeature="master.product_category">
              <EditProductCategoryPage />
            </ProtectedRoute>
          }
        />
        {/* STOP Product Category */}

        {/* START Product List */}
        <Route
          path={PRODUCTLIST}
          element={
            <ProtectedRoute isLogin requiredFeature="master.product_list">
              <ProductListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ADDPRODUCTLIST}
          element={
            <ProtectedRoute isLogin requiredFeature="master.product_list">
              <AddProductListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/product_list/edit_product_list/:id"
          element={
            <ProtectedRoute isLogin requiredFeature="master.product_list">
              <EditProductListPage />
            </ProtectedRoute>
          }
        />
        {/* STOP Product List */}

        {/* START Settings Pages */}
        <Route
          path={SETAPPEARANCE}
          element={
            <ProtectedRoute isLogin requiredFeature="settings">
              <SetAppearancePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={SETFABRICSTYLE}
          element={
            <ProtectedRoute isLogin requiredFeature="settings">
              <SetFabricStylePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ADDFABRICSET}
          element={
            <ProtectedRoute isLogin requiredFeature="settings">
              <AddSetFabricStylePage />
            </ProtectedRoute>
          }
        />

        {/* STOP Settings Pages */}

        <Route
          path={NotHaveAccess}
          element={
            <ProtectedRoute isLogin>
              <NotHaveAccessPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            <ProtectedRoute isLogin>
              <NotFoundPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

export default Navigation;
